import _defineProperty from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as R from 'ramda';
import { soapWithSOA as getSOAP } from 'src/lib/soap_template';
import { SoapCommentsKey, SoapCommentsOldKey } from 'src/types';
export var LoginTestId;

(function (LoginTestId) {
  LoginTestId[LoginTestId["Email"] = 0] = "Email";
  LoginTestId[LoginTestId["Password"] = 1] = "Password";
  LoginTestId[LoginTestId["LoginButton"] = 2] = "LoginButton";
  LoginTestId[LoginTestId["LoginedAvatar"] = 3] = "LoginedAvatar";
  LoginTestId[LoginTestId["LoginedNickname"] = 4] = "LoginedNickname";
  LoginTestId[LoginTestId["LoginedUsername"] = 5] = "LoginedUsername";
  LoginTestId[LoginTestId["LogoutButton"] = 6] = "LogoutButton";
})(LoginTestId || (LoginTestId = {}));

export var BookingTestId;

(function (BookingTestId) {
  BookingTestId[BookingTestId["WeekDayPicker"] = 0] = "WeekDayPicker";
  BookingTestId[BookingTestId["Calendar"] = 1] = "Calendar";
  BookingTestId[BookingTestId["SearchInput"] = 2] = "SearchInput";
  BookingTestId[BookingTestId["SearchButton"] = 3] = "SearchButton";
  BookingTestId[BookingTestId["SearchResultTitle"] = 4] = "SearchResultTitle";
  BookingTestId[BookingTestId["SearchResultModal"] = 5] = "SearchResultModal";
})(BookingTestId || (BookingTestId = {}));

export var GeneralTableTestId;

(function (GeneralTableTestId) {
  GeneralTableTestId[GeneralTableTestId["Table"] = 0] = "Table";
  GeneralTableTestId[GeneralTableTestId["ListItemCount"] = 1] = "ListItemCount";
  GeneralTableTestId[GeneralTableTestId["DeleteBtnModal"] = 2] = "DeleteBtnModal";
  GeneralTableTestId[GeneralTableTestId["ConfirmDeleteButton"] = 3] = "ConfirmDeleteButton";
})(GeneralTableTestId || (GeneralTableTestId = {}));

export var DiagnosisRecordsTestId;

(function (DiagnosisRecordsTestId) {
  DiagnosisRecordsTestId[DiagnosisRecordsTestId["view"] = 0] = "view";
  DiagnosisRecordsTestId[DiagnosisRecordsTestId["edit"] = 1] = "edit";
})(DiagnosisRecordsTestId || (DiagnosisRecordsTestId = {}));

var UserProfileExactKeysTestId;

(function (UserProfileExactKeysTestId) {
  UserProfileExactKeysTestId[UserProfileExactKeysTestId["id"] = 0] = "id";
  UserProfileExactKeysTestId[UserProfileExactKeysTestId["record_number"] = 1] = "record_number";
  UserProfileExactKeysTestId[UserProfileExactKeysTestId["identity_number"] = 2] = "identity_number";
  UserProfileExactKeysTestId[UserProfileExactKeysTestId["birthday"] = 3] = "birthday";
})(UserProfileExactKeysTestId || (UserProfileExactKeysTestId = {}));

var UserProfileTestIdKeys;

(function (UserProfileTestIdKeys) {
  UserProfileTestIdKeys[UserProfileTestIdKeys["uid"] = 0] = "uid";
  UserProfileTestIdKeys[UserProfileTestIdKeys["hormoneScore"] = 1] = "hormoneScore";
  UserProfileTestIdKeys[UserProfileTestIdKeys["hormoneType"] = 2] = "hormoneType";
  UserProfileTestIdKeys[UserProfileTestIdKeys["healthProductScore"] = 3] = "healthProductScore";
  UserProfileTestIdKeys[UserProfileTestIdKeys["id"] = 4] = "id";
  UserProfileTestIdKeys[UserProfileTestIdKeys["record_number"] = 5] = "record_number";
  UserProfileTestIdKeys[UserProfileTestIdKeys["identity_number"] = 6] = "identity_number";
  UserProfileTestIdKeys[UserProfileTestIdKeys["birthday"] = 7] = "birthday";
  UserProfileTestIdKeys[UserProfileTestIdKeys["years"] = 8] = "years";
  UserProfileTestIdKeys[UserProfileTestIdKeys["height"] = 9] = "height";
  UserProfileTestIdKeys[UserProfileTestIdKeys["gender"] = 10] = "gender";
  UserProfileTestIdKeys[UserProfileTestIdKeys["GoProButtonNew"] = 11] = "GoProButtonNew";
  UserProfileTestIdKeys[UserProfileTestIdKeys["GoProButtonOld"] = 12] = "GoProButtonOld";
  UserProfileTestIdKeys[UserProfileTestIdKeys["EditProfileButton"] = 13] = "EditProfileButton";
  UserProfileTestIdKeys[UserProfileTestIdKeys["EditCaseButton"] = 14] = "EditCaseButton";
  UserProfileTestIdKeys[UserProfileTestIdKeys["EditMemoButton"] = 15] = "EditMemoButton";
})(UserProfileTestIdKeys || (UserProfileTestIdKeys = {}));

export var UserProfileTestId = _objectSpread(_objectSpread({}, R.mapObjIndexed(function (item, key) {
  return key;
}, UserProfileTestIdKeys)), R.mapObjIndexed(function (item, key) {
  return key;
}, UserProfileExactKeysTestId));
export var EditOrgClientProfileModalTestId;

(function (EditOrgClientProfileModalTestId) {
  EditOrgClientProfileModalTestId[EditOrgClientProfileModalTestId["real_name"] = 0] = "real_name";
  EditOrgClientProfileModalTestId[EditOrgClientProfileModalTestId["record_number"] = 1] = "record_number";
  EditOrgClientProfileModalTestId[EditOrgClientProfileModalTestId["gender"] = 2] = "gender";
  EditOrgClientProfileModalTestId[EditOrgClientProfileModalTestId["birthday"] = 3] = "birthday";
  EditOrgClientProfileModalTestId[EditOrgClientProfileModalTestId["identity_number"] = 4] = "identity_number";
  EditOrgClientProfileModalTestId[EditOrgClientProfileModalTestId["mobile"] = 5] = "mobile";
})(EditOrgClientProfileModalTestId || (EditOrgClientProfileModalTestId = {}));

export var EditBasicDataModalTestId;

(function (EditBasicDataModalTestId) {
  EditBasicDataModalTestId[EditBasicDataModalTestId["name"] = 0] = "name";
  EditBasicDataModalTestId[EditBasicDataModalTestId["birthday"] = 1] = "birthday";
  EditBasicDataModalTestId[EditBasicDataModalTestId["gender"] = 2] = "gender";
  EditBasicDataModalTestId[EditBasicDataModalTestId["calendar"] = 3] = "calendar";
  EditBasicDataModalTestId[EditBasicDataModalTestId["SaveButton"] = 4] = "SaveButton";
  EditBasicDataModalTestId[EditBasicDataModalTestId["CancelButton"] = 5] = "CancelButton";
})(EditBasicDataModalTestId || (EditBasicDataModalTestId = {}));

export var tabTitle;

(function (tabTitle) {
  tabTitle[tabTitle["TabTitle"] = 0] = "TabTitle";
})(tabTitle || (tabTitle = {}));

var soap = getSOAP();
export var SOAP = R.mapObjIndexed(function (value, key) {
  return _defineProperty({}, key, key);
}, _objectSpread(_objectSpread({}, soap.plan), soap.plan.value));
export var commentWrap;

(function (commentWrap) {
  commentWrap[commentWrap["dr_comments_wrap"] = 0] = "dr_comments_wrap";
  commentWrap[commentWrap["pre_rd_comments_wrap"] = 1] = "pre_rd_comments_wrap";
  commentWrap[commentWrap["post_rd_comments_wrap"] = 2] = "post_rd_comments_wrap";
  commentWrap[commentWrap["pharmacist_comments_wrap"] = 3] = "pharmacist_comments_wrap";
  commentWrap[commentWrap["nurse_comments_wrap"] = 4] = "nurse_comments_wrap";
  commentWrap[commentWrap["dietician_comments_wrap"] = 5] = "dietician_comments_wrap";
})(commentWrap || (commentWrap = {}));

export var TimelineTestId = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, R.mapObjIndexed(function (item, key) {
  return key;
}, SoapCommentsOldKey)), R.mapObjIndexed(function (item, key) {
  return key;
}, SoapCommentsKey)), R.mapObjIndexed(function (item, key) {
  return key;
}, tabTitle)), R.mapObjIndexed(function (item, key) {
  return key;
}, SOAP));
export var DiagnosisTestId = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, R.mapObjIndexed(function (item, key) {
  return key;
}, SoapCommentsOldKey)), R.mapObjIndexed(function (item, key) {
  return key;
}, SoapCommentsKey)), R.mapObjIndexed(function (item, key) {
  return key;
}, commentWrap)), R.mapObjIndexed(function (item, key) {
  return key;
}, SOAP));
export var PrintSoapTestId;

(function (PrintSoapTestId) {
  PrintSoapTestId[PrintSoapTestId["ListModal"] = 0] = "ListModal";
  PrintSoapTestId[PrintSoapTestId["ListModalTitle"] = 1] = "ListModalTitle";
  PrintSoapTestId[PrintSoapTestId["ListCount"] = 2] = "ListCount";
  PrintSoapTestId[PrintSoapTestId["PrintButton"] = 3] = "PrintButton";
  PrintSoapTestId[PrintSoapTestId["PrintListButton"] = 4] = "PrintListButton";
  PrintSoapTestId[PrintSoapTestId["ViewPdfButton"] = 5] = "ViewPdfButton";
  PrintSoapTestId[PrintSoapTestId["PdfContent"] = 6] = "PdfContent";
})(PrintSoapTestId || (PrintSoapTestId = {}));

export var UltrasoundTestId;

(function (UltrasoundTestId) {
  UltrasoundTestId[UltrasoundTestId["printPDF"] = 0] = "printPDF";
  UltrasoundTestId[UltrasoundTestId["save"] = 1] = "save";
  UltrasoundTestId[UltrasoundTestId["upload"] = 2] = "upload";
  UltrasoundTestId[UltrasoundTestId["comment"] = 3] = "comment";
  UltrasoundTestId[UltrasoundTestId["comments"] = 4] = "comments";
  UltrasoundTestId[UltrasoundTestId["level"] = 5] = "level";
})(UltrasoundTestId || (UltrasoundTestId = {}));

export var MeasurementTestId;

(function (MeasurementTestId) {
  MeasurementTestId[MeasurementTestId["printPDF"] = 0] = "printPDF";
  MeasurementTestId[MeasurementTestId["sync"] = 1] = "sync";
  MeasurementTestId[MeasurementTestId["compare"] = 2] = "compare";
  MeasurementTestId[MeasurementTestId["destinationSelect"] = 3] = "destinationSelect";
  MeasurementTestId[MeasurementTestId["destinationOption"] = 4] = "destinationOption";
})(MeasurementTestId || (MeasurementTestId = {}));

export var DeliveryNoteTestId;

(function (DeliveryNoteTestId) {
  DeliveryNoteTestId[DeliveryNoteTestId["printPDF"] = 0] = "printPDF";
  DeliveryNoteTestId[DeliveryNoteTestId["DeleteBtnModal"] = 1] = "DeleteBtnModal";
  DeliveryNoteTestId[DeliveryNoteTestId["ListCount"] = 2] = "ListCount";
  DeliveryNoteTestId[DeliveryNoteTestId["RecordItemCount"] = 3] = "RecordItemCount";
  DeliveryNoteTestId[DeliveryNoteTestId["RecordTable"] = 4] = "RecordTable";
  DeliveryNoteTestId[DeliveryNoteTestId["ArchiveModalButton"] = 5] = "ArchiveModalButton";
  DeliveryNoteTestId[DeliveryNoteTestId["WaitingTable"] = 6] = "WaitingTable";
  DeliveryNoteTestId[DeliveryNoteTestId["DoneTable"] = 7] = "DoneTable";
  DeliveryNoteTestId[DeliveryNoteTestId["ArchiveSomeModalBtn"] = 8] = "ArchiveSomeModalBtn";
  DeliveryNoteTestId[DeliveryNoteTestId["deliverBtn"] = 9] = "deliverBtn";
  DeliveryNoteTestId[DeliveryNoteTestId["UnArchiveModalBtn"] = 10] = "UnArchiveModalBtn";
  DeliveryNoteTestId[DeliveryNoteTestId["updateOrderBtn"] = 11] = "updateOrderBtn";
  DeliveryNoteTestId[DeliveryNoteTestId["PrescriptionWaitingTable"] = 12] = "PrescriptionWaitingTable";
  DeliveryNoteTestId[DeliveryNoteTestId["goToSOAP"] = 13] = "goToSOAP";
  DeliveryNoteTestId[DeliveryNoteTestId["goToOrder"] = 14] = "goToOrder";
  DeliveryNoteTestId[DeliveryNoteTestId["ArchiveAllBtn"] = 15] = "ArchiveAllBtn";
  DeliveryNoteTestId[DeliveryNoteTestId["HistoryRecordBtn"] = 16] = "HistoryRecordBtn";
  DeliveryNoteTestId[DeliveryNoteTestId["HistoryDrugModal"] = 17] = "HistoryDrugModal";
  DeliveryNoteTestId[DeliveryNoteTestId["DeliverDetailsModal"] = 18] = "DeliverDetailsModal";
  DeliveryNoteTestId[DeliveryNoteTestId["DeliverDetailsModal_chinese_name"] = 19] = "DeliverDetailsModal_chinese_name";
  DeliveryNoteTestId[DeliveryNoteTestId["DeliverDetailsModal_english_name"] = 20] = "DeliverDetailsModal_english_name";
  DeliveryNoteTestId[DeliveryNoteTestId["DeliverDetailsModal_frequency"] = 21] = "DeliverDetailsModal_frequency";
  DeliveryNoteTestId[DeliveryNoteTestId["DeliverDetailsModal_single_amount"] = 22] = "DeliverDetailsModal_single_amount";
  DeliveryNoteTestId[DeliveryNoteTestId["DeliverDetailsModal_days"] = 23] = "DeliverDetailsModal_days";
  DeliveryNoteTestId[DeliveryNoteTestId["DeliverReturnDrugModal"] = 24] = "DeliverReturnDrugModal";
  DeliveryNoteTestId[DeliveryNoteTestId["DeliverReturnDrugModal_name"] = 25] = "DeliverReturnDrugModal_name";
  DeliveryNoteTestId[DeliveryNoteTestId["DeliverReturnDrugModal_note"] = 26] = "DeliverReturnDrugModal_note";
  DeliveryNoteTestId[DeliveryNoteTestId["DeliverReturnDrugModal_ReturnBtn"] = 27] = "DeliverReturnDrugModal_ReturnBtn";
  DeliveryNoteTestId[DeliveryNoteTestId["PrintPDFModal"] = 28] = "PrintPDFModal";
  DeliveryNoteTestId[DeliveryNoteTestId["PrintPDFModalDownloadPdfButton"] = 29] = "PrintPDFModalDownloadPdfButton";
  DeliveryNoteTestId[DeliveryNoteTestId["PrintPDFModalCheckAll"] = 30] = "PrintPDFModalCheckAll";
  DeliveryNoteTestId[DeliveryNoteTestId["dr_comments"] = 31] = "dr_comments";
  DeliveryNoteTestId[DeliveryNoteTestId["pre_rd_comments"] = 32] = "pre_rd_comments";
  DeliveryNoteTestId[DeliveryNoteTestId["post_rd_comments"] = 33] = "post_rd_comments";
  DeliveryNoteTestId[DeliveryNoteTestId["pharmacist_comments"] = 34] = "pharmacist_comments";
  DeliveryNoteTestId[DeliveryNoteTestId["nurse_comments"] = 35] = "nurse_comments";
  DeliveryNoteTestId[DeliveryNoteTestId["dr_comments_wrap"] = 36] = "dr_comments_wrap";
  DeliveryNoteTestId[DeliveryNoteTestId["pre_rd_comments_wrap"] = 37] = "pre_rd_comments_wrap";
  DeliveryNoteTestId[DeliveryNoteTestId["post_rd_comments_wrap"] = 38] = "post_rd_comments_wrap";
  DeliveryNoteTestId[DeliveryNoteTestId["pharmacist_comments_wrap"] = 39] = "pharmacist_comments_wrap";
  DeliveryNoteTestId[DeliveryNoteTestId["nurse_comments_wrap"] = 40] = "nurse_comments_wrap";
  DeliveryNoteTestId[DeliveryNoteTestId["ToDrComment"] = 41] = "ToDrComment";
  DeliveryNoteTestId[DeliveryNoteTestId["ToDieticianComment"] = 42] = "ToDieticianComment";
  DeliveryNoteTestId[DeliveryNoteTestId["ToPharmacistComment"] = 43] = "ToPharmacistComment";
  DeliveryNoteTestId[DeliveryNoteTestId["ToNurseComment"] = 44] = "ToNurseComment";
  DeliveryNoteTestId[DeliveryNoteTestId["OrderStatusSelect"] = 45] = "OrderStatusSelect";
  DeliveryNoteTestId[DeliveryNoteTestId["DeliverStatusSelect"] = 46] = "DeliverStatusSelect";
  DeliveryNoteTestId[DeliveryNoteTestId["DrugArchiveStatusSelect"] = 47] = "DrugArchiveStatusSelect";
  DeliveryNoteTestId[DeliveryNoteTestId["DrugOweStatusSelect"] = 48] = "DrugOweStatusSelect";
  DeliveryNoteTestId[DeliveryNoteTestId["DrugReturnStatusSelect"] = 49] = "DrugReturnStatusSelect";
})(DeliveryNoteTestId || (DeliveryNoteTestId = {}));

export var DateRangePickerTestId;

(function (DateRangePickerTestId) {
  DateRangePickerTestId[DateRangePickerTestId["lastMonth"] = 0] = "lastMonth";
  DateRangePickerTestId[DateRangePickerTestId["thisMonth"] = 1] = "thisMonth";
  DateRangePickerTestId[DateRangePickerTestId["yesterday"] = 2] = "yesterday";
  DateRangePickerTestId[DateRangePickerTestId["dayBeforeYesterday"] = 3] = "dayBeforeYesterday";
  DateRangePickerTestId[DateRangePickerTestId["today"] = 4] = "today";
  DateRangePickerTestId[DateRangePickerTestId["tomorrow"] = 5] = "tomorrow";
  DateRangePickerTestId[DateRangePickerTestId["startDate"] = 6] = "startDate";
  DateRangePickerTestId[DateRangePickerTestId["endDate"] = 7] = "endDate";
  DateRangePickerTestId[DateRangePickerTestId["startDateCalendar"] = 8] = "startDateCalendar";
  DateRangePickerTestId[DateRangePickerTestId["endDateCalendar"] = 9] = "endDateCalendar";
  DateRangePickerTestId[DateRangePickerTestId["nearlyTwoMonths"] = 10] = "nearlyTwoMonths";
  DateRangePickerTestId[DateRangePickerTestId["nearlySixMonths"] = 11] = "nearlySixMonths";
  DateRangePickerTestId[DateRangePickerTestId["thisYear"] = 12] = "thisYear";
})(DateRangePickerTestId || (DateRangePickerTestId = {}));

export var TestIdTblKeys;

(function (TestIdTblKeys) {
  TestIdTblKeys[TestIdTblKeys["total_amount"] = 0] = "total_amount";
  TestIdTblKeys[TestIdTblKeys["medicine_amount"] = 1] = "medicine_amount";
})(TestIdTblKeys || (TestIdTblKeys = {}));

export var TestIdTblExactKeys;

(function (TestIdTblExactKeys) {
  TestIdTblExactKeys[TestIdTblExactKeys["category"] = 0] = "category";
  TestIdTblExactKeys[TestIdTblExactKeys["english_name"] = 1] = "english_name";
  TestIdTblExactKeys[TestIdTblExactKeys["chinese_name"] = 2] = "chinese_name";
  TestIdTblExactKeys[TestIdTblExactKeys["single_amount"] = 3] = "single_amount";
  TestIdTblExactKeys[TestIdTblExactKeys["frequency"] = 4] = "frequency";
  TestIdTblExactKeys[TestIdTblExactKeys["days"] = 5] = "days";
  TestIdTblExactKeys[TestIdTblExactKeys["compliance"] = 6] = "compliance";
})(TestIdTblExactKeys || (TestIdTblExactKeys = {}));

export var TblTestIdKeys;

(function (TblTestIdKeys) {
  TblTestIdKeys[TblTestIdKeys["created_at"] = 0] = "created_at";
  TblTestIdKeys[TblTestIdKeys["action"] = 1] = "action";
  TblTestIdKeys[TblTestIdKeys["creater_name"] = 2] = "creater_name";
  TblTestIdKeys[TblTestIdKeys["output_amount"] = 3] = "output_amount";
  TblTestIdKeys[TblTestIdKeys["archived"] = 4] = "archived";
  TblTestIdKeys[TblTestIdKeys["returned"] = 5] = "returned";
})(TblTestIdKeys || (TblTestIdKeys = {}));

export var TestIdTblTagKeys;

(function (TestIdTblTagKeys) {
  TestIdTblTagKeys[TestIdTblTagKeys["plan_suggest"] = 0] = "plan_suggest";
  TestIdTblTagKeys[TestIdTblTagKeys["exercise_prescription"] = 1] = "exercise_prescription";
})(TestIdTblTagKeys || (TestIdTblTagKeys = {}));

export var TblTestId = _objectSpread(_objectSpread(_objectSpread({}, R.mapObjIndexed(function (item, key) {
  return key;
}, TestIdTblKeys)), R.mapObjIndexed(function (item, key) {
  return key;
}, TestIdTblExactKeys)), R.mapObjIndexed(function (item, key) {
  return key;
}, TestIdTblTagKeys));